import { render } from "./ReportsComingSoonButton.vue?vue&type=template&id=0cf51753&scoped=true"
import script from "./ReportsComingSoonButton.vue?vue&type=script&lang=js"
export * from "./ReportsComingSoonButton.vue?vue&type=script&lang=js"

import "./ReportsComingSoonButton.vue?vue&type=style&index=0&id=0cf51753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf51753"]])

export default __exports__